module.exports = __webpack_public_path__ + "static/langojango-korean-language-phrasebook-89a89bb132dabe0b6c9d6094f6c57688.png";